import { ArchiveList } from '@components/archiveList';
import { FundsIntroduction } from '@components/fundsIntroduction';
import { BaseData } from '@widgets/baseData';
import { PerformanceByYear } from '@widgets/performanceByYear';
import PerformanceOverview from '@widgets/performanceOverview';
import { TrancheSelection } from '@widgets/trancheSelection';
import { Widget } from '@widgets/widget';

export const TypeMap: Record<string, React.ComponentType<any>> = {
  BaseData,
  PerformanceByYear,
  PerformanceOverview,
  FundsIntroduction,
  TrancheSelection,
  ArchiveList,
  Widget,
};
